import React from 'react'
import Language from "./language"

class Header extends React.Component {


    render() {

        return (
            <header style={{
                display: "flex"
            }}>
                <div className="container">
                    <div className="language-menu">
                        <Language />
                    </div>
                </div>
            </header>
        )
    }
}

export default Header
